<template>
  <b-container class="bv-example-row shopping-cart-line">
    <b-row align-v="center">
      <b-col cols="2">
        <b-img
          :src="(product.picture && product.picture.picture)? product.picture.picture: fallback"
          fluid-grow
          @error="imageLoadError"
        />
      </b-col>
      <b-col cols="3">
        {{ product.description }}
      </b-col>
      <b-col cols="3">
        <b-form-input
          type="number"
          min="1"
          v-model="quantity">
        </b-form-input>
      </b-col>
      <b-col cols="2">
        {{ price }}
      </b-col>
      <b-col cols="2" class="pr-0 pl-4">
        <b-link @click="removeItem()" class="pull-right table-link-action icon-link-primary">
          <font-awesome-icon :icon="['far', 'times-circle']" />
        </b-link>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import debounce from "lodash/debounce";
export default {
  name: "shopping-cart-line",
  props: {
    product: Object,
    priceUuid: String,
  },
  fallbackI18n: {
    messages: {
      und: {
        shopping_cart_line: {
          error: {
            quantity_change_error: "Cannot modify quantity",
          },
        },
      },
    },
  },
  data() {
    return {
      busy: false,
      fallback: require("@/static/fallback_drug_picture.png"),
    };
  },
  computed: {
    price() {
      return this.$formatMoney(
        this.product.price.all_included_price,
        this.product.price.all_included_price_currency
      );
    },
    quantity: {
      // getter
      get: function () {
        return String(this.product.quantity);
      },
      // setter
      set: debounce(function (newValue) {
        if (this.busy) {
          return;
        }
        const number = Number.parseInt(newValue);
        if (Number.isNaN(number)) {
          return;
        }
        this.busy = true;
        try {
          this.$store
            .dispatch("shoppingcart/SET_QUANTITY", {
              price_uuid: this.priceUuid,
              item_uuid: this.product.uuid,
              quantity: number,
              previous_quantity: this.product.quantity,
            })
            .then(
              () => {
                this.busy = false;
              },
              (err) => {
                this.busy = false;
                this.$sentry({ capture: err });
                this.mnotify_error({
                  text: this.$t(
                    "shopping_cart_line.error.quantity_change_error"
                  ),
                });
              }
            );
        } catch (e) {
          this.busy = false;
          this.$sentry({ capture: e });
          this.mnotify_error({
            title: "Error",
            text: this.$t("shopping_cart_line.error.quantity_change_error"),
          });
        }
      }, 500),
    },
  },
  methods: {
    removeItem() {
      this.$store.dispatch("shoppingcart/REMOVE_PRODUCT", {
        price_uuid: this.priceUuid,
        item_uuid: this.product.uuid,
      });
    },
    imageLoadError(evt) {
      evt.srcElement.src = require("@/static/fallback_drug_picture.png");
    },
  },
};
</script>


<style lang="scss" scoped>
.shopping-cart-line {
  font-size: $font-size-default;
}
</style>
